import {get} from '@/api'
import setShareInfo from './share'
import _ from 'lodash'
import store from '../store'
const routePushShare = () => {
  get({
    road: 'getWxConfig',
    version: 'v2'
  })
  .then(res=>{
    wx.config({
      appId: res.appid,
      timestamp: res.timeStamp,
      nonceStr: res.nonce_str,
      signature: sha1(
        `jsapi_ticket=${res.jsapiTicket}&noncestr=${res.nonce_str}&timestamp=${res.timeStamp}&url=${window.location.href.split('#')[0]}`
        ),
      jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage',"chooseWXPay"]
    });
    wx.ready(()=>{
      setShareInfo(_.get(store.state.nextPageInfo, 'meta'))
    })
  }).catch( err => {
    const { code } = err
    if(code === 401 || code === '401') {
      store.commit('WRITEUSERINFO',null)
      store.commit('WRITEUSERLEVEL',null)
    }
  })
}
export default routePushShare